<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <h1>Logowanie</h1>
                <p class="text-muted">Zaloguj się na swoje konto</p>
                <p style="color: red" v-if="errors.length">
                  <b>Please correct the following error(s):</b>
                  <ul>
                    <li v-for="error in errors" :key="error">{{ error }}</li>
                  </ul>
                </p>
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="icon-user"></i>
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <input type="email" v-model="email" class="form-control" placeholder="Email">
                </b-input-group>
                <b-input-group class="mb-4">
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="icon-lock"></i>
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <input type="password" v-model="password" class="form-control" placeholder="Hasło">
                </b-input-group>
                <b-row>
                  <b-col cols="6">
                    <b-button @click="login" variant="primary" class="px-4">Zaloguj</b-button>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      errors: [],
      email: "",
      password: "",
      error: null
    };
  },
  mounted() {},
  computed: {
    strategies: () => [],
    redirect() {
      return (
        this.$route.query.redirect &&
        decodeURIComponent(this.$route.query.redirect)
      );
    },
    isCallback() {
      return Boolean(this.$route.query.callback);
    }
  },
  methods: {
    async login() {
      this.error = null;
      this.errors = [];
      if (!this.email) {
        this.errors.push("Email jest wymagany");
      } else if (!this.validEmail(this.email)) {
        this.errors.push("Nieprawidłowy adres email");
      }
      if (!this.password) {
        this.errors.push("Hasło jest wymagane");
      }

      if (this.errors.length) {
        return;
      }

      const login = await this.$auth
        .login({
          data: { email: this.email, password: this.password },
          fetchUser: true
        })
        .catch(e => {
          if (e.response.data.message == "User doesn't exist") {
            this.errors.push("Nieprawidłowy login lub hasło");
          }
        });
    },
    validEmail: function(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  }
};
</script>
